<template>
  <div class="notification-bar">
    {{msgText}}
  </div>
</template>

<script>
export default {
  name: 'NotificationBar',
  props: ['msgText']
}
</script>

<style>
  .notification-bar {
    background: #DFF7FF;
    margin-left: calc(-50vw + 50%);
    margin-right: calc(-50vw + 50%);
    font-size: 16px;
    padding: 16px 20px;
    text-align: center;
  }
</style>